import React from 'react';

/**
 * LoadingLogo Component
 * 
 * Animated Era logo loading indicator with pulse/fade effect
 * Usage: <LoadingLogo size="lg" />
 * 
 * @param {string} size - Size of logo: 'sm' (256px), 'md' (384px), 'lg' (512px), 'xl' (768px)
 * @param {string} text - Optional loading text below logo
 */
const LoadingLogo = ({ size = 'md', text = 'Loading...' }) => {
  const sizeMap = {
    sm: 256,   // 256px
    md: 384,   // 384px
    lg: 512,   // 512px - larger and more prominent
    xl: 768    // 768px
  };

  const logoSize = sizeMap[size];

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px]">
      {/* Pulsing Era Logo */}
      <div 
        style={{
          width: `${logoSize}px`,
          height: `${logoSize}px`,
          maxWidth: '90vw',  // Don't overflow on small screens
          maxHeight: '90vw'
        }}
      >
        <img
          src="/era-logo.jpg"
          alt="Era Digital Logo"
          className="w-full h-full object-cover rounded-xl shadow-2xl"
          style={{
            objectPosition: 'center',
            animation: 'smoothPulse 2s ease-in-out infinite'
          }}
        />
        <style>{`
          @keyframes smoothPulse {
            0%, 100% { 
              opacity: 0.85;
              filter: brightness(0.95);
              transform: scale(1);
            }
            50% { 
              opacity: 1;
              filter: brightness(1.05);
              transform: scale(1.02);
            }
          }
        `}</style>
      </div>
      
      {/* Loading Text */}
      {text && (
        <p className="mt-8 text-gray-400 text-lg font-medium">
          {text}
        </p>
      )}
    </div>
  );
};

export default LoadingLogo;
